import { Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import { viewClassName } from '@angular/compiler';
import { SharedService } from '../shared.service';
import { SOFTWARE_ENGINEERING_TABS, DATA_SERVICES_TABS, GCC_ODC_TABS, STAFFING_TABS } from '../managed-service-tabs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  list;
  mainList
  managedService;
  managedServiceSoftEng;
  isOpen = true;
  isSlideOpen = true;
  @ViewChild("dropDown",{static:true}) dropDown: ElementRef;

  constructor(private sharedservice: SharedService) {
    this.mainList = [
      {name: 'Products', routerlink:'product'},
      {name: 'Advance Solution', routerlink:'advance-solution'},
      {name: 'AI & Automation', routerlink:'ai'},

  ];
    this.list = [
        {name: 'About Arkedge', link: 'about'},
        {name: 'Our Happy Clients', link: 'clients'},
        // {name: 'News And Event Update', link: 'news-events'},
        {name: 'Testimonial Client Speaks', link: 'testimonials'},
        {name: 'industries', link: 'industries'},
        {name: 'Technology', link: 'technology'},
        {name: 'Career', link: 'career'},
        // {name: 'Sitemap', link: 'sitemap'},
        {name: 'Contact Us', link: 'contact'}
    ];
    this.managedService = [
      {name: 'Software Engineering', routerLink: "software-engineering",
      managedServiceList : SOFTWARE_ENGINEERING_TABS},
      {name: 'Data Services', routerLink: "data-services",
      managedServiceList : DATA_SERVICES_TABS},
      {name: 'GCC & ODC Solutions', routerLink: "gcc-odc-solutions",
      managedServiceList : GCC_ODC_TABS},
      {name: 'IT Staffing & Training', routerLink: "staffing-services",
      managedServiceList : STAFFING_TABS}
    ];
  }

  get isScrolled() {
    return window.scrollY > 0
  }

  slideToggel() {
    const body = document.getElementsByTagName('body')[0];
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      body.classList.add('remove-scroll');
    } else {
      body.classList.remove('remove-scroll'); 
    }
  }


  ngOnInit() {
  }

  changeStyle(){
     this.dropDown.nativeElement.hidden = false;
  }

  removeStyle() {
    this.dropDown.nativeElement.hidden = true;
  }

  getUrl(i, title) {
    this.dropDown.nativeElement.hidden = true;
    this.sharedservice.nextMessage(i, title);
    if (!this.isOpen){
      this.slideToggel();
    }   
  }
}
